import { render, staticRenderFns } from "./addSampleInfo.vue?vue&type=template&id=8ae05d6c&scoped=true&"
import script from "./addSampleInfo.vue?vue&type=script&lang=js&"
export * from "./addSampleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae05d6c",
  null
  
)

export default component.exports